import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import { RouteComponentProps, navigate } from '@reach/router';
import { Link } from '@reach/router';
import {
    Paper,
    Card,
    Typography,
    CardContent,
    CardActions,
    Grid
} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import * as firebase from 'firebase';

const useStyles = makeStyles({
    root: {
      minWidth: 275,
      maxWidth: '25%',
      marginBottom: '10%',
      textAlign: 'center'
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    paper: {
        padding: '4%',
        margin: '2%'
    }
  });

export default function Dashboard(props) {
    const classes = useStyles();
    let money = 1000;
    const [currency, setCurrency] = useState('');
    const [amount, setAmount] = useState(0);
    let startupCount = 6;
    let investorCount = 6;

    const loadData = () => {
      var uid = firebase.auth().currentUser.uid;
      var resp = firebase.database().ref('users/'+ uid);
      console.log()
      resp.on('value', function(snapshot) {
        var val = snapshot.val()
        setCurrency(val.currency);
        setAmount(val.amount);
      });
    }

    useEffect(() => {
        loadData();
      }, []);

    return (
        <div>
            <Paper className={classes.paper}>
                <h1>Dashboard</h1>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Card className={classes.root}>
                        <CardContent>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Funding Provided
                            </Typography>
                            <Typography variant="h5" component="h2">
                            {currency} {money}
                            </Typography>
                            {/* <Typography className={classes.pos} color="textSecondary">
                            adjective
                            </Typography> */}
                            <Typography variant="h6" component="h3">
                            {startupCount} Startups
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small">View All</Button>
                            <Button size="small">Provide More</Button>
                        </CardActions>
                    </Card>
                  </Grid>
                  <Grid item xs={6}>
                    <Card className={classes.root}>
                        <CardContent>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Funding Received
                            </Typography>
                            <Typography variant="h5" component="h2">
                            {currency} {money}
                            </Typography>
                            {/* <Typography className={classes.pos} color="textSecondary">
                            adjective
                            </Typography> */}
                            <Typography variant="h6" component="h3">
                            {investorCount} Angels
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small">View All</Button>
                            <Button size="small">Make Request</Button>
                        </CardActions>
                    </Card>
                  </Grid>
                </Grid>
            </Paper>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/dashboard.js